import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
import { useNavigate } from "react-router-dom";
import "./Faq.css";
import AskFaq from "../../../Images/askFaq.png";
function Faq() {
    let navigate = useNavigate();
    const TermsCondition = () => {
        let path = `../TermsCondition`;
        navigate(path, { state: { plan: "terms" } });
    };
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={12}>
              <h1>Frequently Asked Questions</h1>
             
              <Row>
              <Col md={8}>
              <Accordion defaultActiveKey="1">
                {/* <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Q.What is interest on ledger balance?
                  </Accordion.Header>
                                          <Accordion.Body>
                                              <p>The interest on ledger balance applies to cash ledger credit amounts regardless of margin shortfall, with no capping on the amount of interest a customer can earn. Please see <a className="linkhere" onClick={() => TermsCondition()}>here</a> for further information.</p>
                  </Accordion.Body>
                </Accordion.Item> */}
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                    Q. How can I invest in stocks with Moneysukh?
                  </Accordion.Header>
                  <Accordion.Body>
                    <ul>
                      {/* <li> Visit trade.moneysukh.com and login through your Moneysukh User ID & password</li> */}
                      <li> Visit <a href="https://online.moneysukh.com" target="_blank">https://online.moneysukh.com</a> and login with your Moneysukh User ID & password.</li>
                      <li> Search for the stock you want to buy. You need to ensure to have a sufficient amount for buying the shares.</li>
                      <li>Select the price at which you want to buy the stock.</li>
                      <li>Conclude the transaction and the stock s will be credit to your demat account.</li>
                    </ul>
                    <p>
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                    Q. What are different tools provided by Moneysukh?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>We are providing 3 tools to help investors make informed decision.</p>
                    <ul>
                     <li> Foxtrader – Best charting experience</li>
                     {/* <li>Tradetron – For algos </li> */}
                     <li>Smart Options: Trade Options Directly from Real Time Charts</li>
                      <li>Traderadar – Option strategies and screeners</li>
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                    Q Are screeners free to use?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                      Yes, all screeners are absolutely free to use.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                    Q. Can I trade in the currency and commodity market using my regular trading account?
                  </Accordion.Header>
                  <Accordion.Body>
                    <p>
                    Of course yes, you can trade in the currency and commodity market using your regular trading account.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
              </Col>
                <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
            </Row>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default Faq;
